import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import endPoint from "../../redux/EndPoint/endpoint";
import { useNavigate } from "react-router-dom";

const SellerResetPassword = () => {
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            email,
            otp,
            newPassword,
        };
        try {
            setLoading(true);
            const res = await axios.post(
                `${endPoint.SellerResetPassword}`,
                payload
            );
            navigate("/SellerLogin");
            toast.success(res.data?.message || "Password reset successful");
        } catch (error) {
            toast.error(
                error.response?.data?.message || "Invalid OTP or Email"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-blue-200 to-white py-10">
            <div className="bg-white rounded-2xl shadow-lg max-w-md p-8 space-y-8 w-[90%]">

                <div className="text-center">
                    <h2 className="text-3xl font-bold text-gray-800">
                        Verify OTP
                    </h2>
                    <p className="text-gray-600 mt-2">
                        Enter OTP and set a new password
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-5">

                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Email
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full mt-2 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500"
                            placeholder="Enter your email"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            OTP
                        </label>
                        <input
                            type="text"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            required
                            maxLength={6}
                            className="w-full mt-2 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 tracking-widest text-center"
                            placeholder="Enter 6-digit OTP"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            New Password
                        </label>
                        <input
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                            className="w-full mt-2 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500"
                            placeholder="Enter new password"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold hover:bg-indigo-700 transition"
                    >
                        {loading ? "Please wait..." : "Reset Password"}
                    </button>

                </form>
            </div>
        </div>
    );
};

export default SellerResetPassword;
